import { render, staticRenderFns } from "./SidHorizontalAlign.vue?vue&type=template&id=be833e56"
import script from "./SidHorizontalAlign.vue?vue&type=script&lang=js"
export * from "./SidHorizontalAlign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports